const icon = require('./icons/out-of-bed-100.png')

export const OutOfBedIcon = () => {
    return <img src={icon} alt="out of bed icon" className="w-full h-full"/>
}
